import React from "react";
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import Input from "../../../component-lib/Atoms/Input/Input";
import Button from "../../../component-lib/Molecules/button/Button";
import { TEXT_CONSTANTS } from "../../../utils/text-constants/textConstants";
import BootstrapDialog from "../../../utils/bootstrap-dialog-style/BootstrapDialog";

interface TaskTypeDialogProps {
  isOpen: boolean;
  handleData: (data: any) => void;
  handleClose: () => void;
  defaultTaskTypeData: any;
}

export default function TaskTypeDialog({
  isOpen = false,
  handleClose,
  handleData,
  defaultTaskTypeData,
}: TaskTypeDialogProps) {
  const dialogHeading = defaultTaskTypeData?.name
    ? "Edit Task Type"
    : "Add Task Type";
  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .max(50, "Task type should not exceed 50 characters")
      .required("Task type is required"),
  });

  return (
    <BootstrapDialog
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          handleClose();
        }
      }}
      aria-labelledby="customized-dialog-title"
      open={isOpen}
    >
      <Formik
        initialValues={{
          name: `${defaultTaskTypeData?.name || ""}`,
        }}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={(values, { setSubmitting }) => {
          try {
            handleData(values);
          } catch (error) {
            console.log(error);
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {({
          errors,
          values,
          touched,
          isValid,
          dirty,
          setFieldValue,
          handleBlur,
          handleSubmit,
        }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <DialogTitle
                sx={{
                  m: 0,
                  p: 2,
                  fontWeight: 600,
                  fontSize: "18px",
                  fontFamily: "inter",
                }}
                id="customized-dialog-title"
              >
                {dialogHeading}
              </DialogTitle>
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={(theme) => ({
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: theme.palette.grey[500],
                })}
              >
                <CloseIcon />
              </IconButton>
              <hr />
              {/* MAIN CONTENT */}
              <DialogContent>
                <div
                  style={{
                    overflow: "auto",
                    display: "grid",
                    gridTemplateColumns: "1fr",
                    gap: "16px",
                  }}
                >
                  <div className="pt-4">
                    <Input
                      textFieldLabel="Task Type"
                      maxLength={50}
                      size="small"
                      name="name"
                      value={values.name}
                      onChangeCb={(e) => {
                        setFieldValue("name", e.target.value);
                      }}
                      onBlur={handleBlur}
                      error={touched.name && Boolean(errors.name)}
                      helperText={touched.name ? errors.name : undefined}
                    />
                  </div>
                </div>
              </DialogContent>

              {/* ACTION BUTTON */}
              <DialogActions style={{ padding: "24px" }}>
                {defaultTaskTypeData?.name && (
                  <Button
                    label={TEXT_CONSTANTS?.CANCEL}
                    variant="outlined"
                    onClickCb={handleClose}
                    style={{
                      width: "120px",
                      height: "44px",
                      padding: "12px 20px",
                      fontSize: "16px",
                      backgroundColor: "white",
                      border: "none",
                      color: "#393939",
                    }}
                  />
                )}
                <Button
                  type="submit"
                  label={TEXT_CONSTANTS?.SAVE}
                  variant="contained"
                  onClickCb={() => {}}
                  style={{
                    width: "200px",
                    height: "44px",
                    padding: "12px 20px",
                    fontSize: "16px",
                  }}
                ></Button>
              </DialogActions>
            </Form>
          );
        }}
      </Formik>
    </BootstrapDialog>
  );
}
